import { comboboxActions, findNode, getEditorString } from '@udecode/plate';
import { BufferEditor, BufferValue } from '~/editor/BufferEditor/types.plate';
import {
  getTwitterPublicSuggestions,
  TwitterSuggestionResultType,
} from '~/utils/channels/twitter';
import { TwitterPublicSuggestionResponse } from '~/utils/channels/twitter/types';
import { AutocompleteItem } from '../../autocomplete';
import { TwitterHashtagInputElement } from '../nodes';

// Parse suggestion response into autocomplete
// items for display in combobox
export function parseSuggestions(
  suggestions: TwitterPublicSuggestionResponse
): AutocompleteItem[] {
  return suggestions.topics.map(({ topic }) => ({
    key: topic,
    text: topic.replace('#', ''),
    data: { handle: topic },
  }));
}

/**
 * Callback executed to fetch new Twitter hashtag suggestions.
 *
 * Updates combobox items on success.
 */
export const getNewSuggestionsOnHashtagUpdate = (editor: BufferEditor) => {
  const hashtagEntry = findNode<TwitterHashtagInputElement, BufferValue>(
    editor,
    { match: (n) => TwitterHashtagInputElement.is(n) }
  );

  if (hashtagEntry) {
    const searchString = getEditorString(editor, hashtagEntry[1]).replace(
      TwitterHashtagInputElement.trigger,
      ''
    );

    comboboxActions.items([]);
    getTwitterPublicSuggestions(
      searchString,
      TwitterSuggestionResultType.Hashtags
    ).then((searchResults) => {
      if (searchResults) {
        comboboxActions.items(parseSuggestions(searchResults));
      }
    });
  }
};
